import { render, staticRenderFns } from "./ConsultaCliente.vue?vue&type=template&id=fcbc3602"
import script from "./ConsultaCliente.vue?vue&type=script&lang=js"
export * from "./ConsultaCliente.vue?vue&type=script&lang=js"
import style0 from "./ConsultaCliente.vue?vue&type=style&index=0&id=fcbc3602&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports